import React from "react";
import GenericPullConfigListing from "../GenericPullConfigListing";
import AppcheckCredentialsForm from "./AppcheckCredentialsForm";
import AppcheckMappingForm from "./AppcheckMappingForm";

export default function AppcheckConfigListing(props) {

  return (
    <GenericPullConfigListing
      {...props}
      toolName={props.name}
      MappingForm={AppcheckMappingForm}
      CredentialsForm={AppcheckCredentialsForm}
      componentName="Scan Name"
      componentKey="scanName"
    />
  );
}
